/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CircleEnduserData } from '../model/circleEnduserData';
import { EnduserCirclePayload } from '../model/enduserCirclePayload';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EnduserCircleService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create circle enduser
     * 
     * @param circleId Circle
     * @param payload Enduser circle
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createCircleEnduser(circleId: string, payload?: EnduserCirclePayload, observe?: 'body', reportProgress?: boolean): Observable<CircleEnduserData>;
    public createCircleEnduser(circleId: string, payload?: EnduserCirclePayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CircleEnduserData>>;
    public createCircleEnduser(circleId: string, payload?: EnduserCirclePayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CircleEnduserData>>;
    public createCircleEnduser(circleId: string, payload?: EnduserCirclePayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (circleId === null || circleId === undefined) {
            throw new Error('Required parameter circleId was null or undefined when calling createCircleEnduser.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CircleEnduserData>(`${this.basePath}/api/circles/${encodeURIComponent(String(circleId))}`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete circle enduser
     * 
     * @param circleId Circle
     * @param enduserId Enduser
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteCircleEnduser(circleId: string, enduserId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteCircleEnduser(circleId: string, enduserId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteCircleEnduser(circleId: string, enduserId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteCircleEnduser(circleId: string, enduserId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (circleId === null || circleId === undefined) {
            throw new Error('Required parameter circleId was null or undefined when calling deleteCircleEnduser.');
        }

        if (enduserId === null || enduserId === undefined) {
            throw new Error('Required parameter enduserId was null or undefined when calling deleteCircleEnduser.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/circles/${encodeURIComponent(String(circleId))}/endusers/${encodeURIComponent(String(enduserId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get circle enduser list
     * 
     * @param circleId Circle
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCircleEnduserList(circleId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CircleEnduserData>>;
    public getCircleEnduserList(circleId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CircleEnduserData>>>;
    public getCircleEnduserList(circleId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CircleEnduserData>>>;
    public getCircleEnduserList(circleId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (circleId === null || circleId === undefined) {
            throw new Error('Required parameter circleId was null or undefined when calling getCircleEnduserList.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<CircleEnduserData>>(`${this.basePath}/api/circles/${encodeURIComponent(String(circleId))}/endusers`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
